import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useLibrarySubject } from "@/modules/mypages/libraries/components";
import { CLASS_INDEX_PAGE } from "@/settings/constant";
import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { useRouter } from "next/router";
import { createContext, useCallback, useEffect, useMemo, useRef } from "react";
import { postClass } from "src/api/class";
import useClassStore from "src/store/class";
import { useMainPageStore } from "src/store/main";
import { useModal } from "src/utils/overlay";
import { StyledModal } from ".";
import NewClassStep1 from "./NewClassStep1";
export const NewClassContext = /*#__PURE__*/ createContext(null);
const NewClass = ()=>{
    const [isSelectBooksModalOpen, { open: openSelectBooksModal , close: closeSelectBooksModal  }] = useModal("selectBooksModal");
    const data = useClassStore((state)=>state.adding);
    const userSourceBooks = useClassStore((state)=>state.userSourceBooks);
    const { setAdding , openNewClass , closeNewClass , setUserSourceBooks  } = useClassStore((param)=>{
        let { setAdding , openNewClass , closeNewClass , setUserSourceBooks  } = param;
        return {
            setAdding,
            openNewClass,
            closeNewClass,
            setUserSourceBooks
        };
    });
    const { setSubject  } = useMainPageStore((param)=>{
        let { setSubject  } = param;
        return {
            setSubject
        };
    });
    const subjectOnLibrary = useLibrarySubject();
    const subjectOnMain = useMainPageStore((state)=>state.subject);
    const { subject , isNewClassOpen  } = useMemo(()=>({
            subject: subjectOnLibrary || subjectOnMain,
            isNewClassOpen: data.open
        }), [
        subjectOnLibrary,
        subjectOnMain,
        data
    ]);
    useEffect(()=>{
        if (isNewClassOpen) {
            setAdding({
                name: ""
            });
            setUserSourceBooks({
                type: "new",
                books: undefined
            });
            if (subject) {
                setSubject(subject);
            }
        }
    }, [
        isNewClassOpen,
        setAdding,
        setSubject,
        setUserSourceBooks,
        subject
    ]);
    useEffect(()=>{
        if (data.step === 2) {
            openSelectBooksModal();
        }
    }, [
        data.step,
        openSelectBooksModal
    ]);
    useEffect(()=>{
        if (isSelectBooksModalOpen) {
            closeNewClass();
        } else {
            setAdding({
                step: 1
            });
        }
    }, [
        isSelectBooksModalOpen,
        closeNewClass,
        setAdding
    ]);
    const classMutation = useMutation(postClass);
    const { push  } = useRouter();
    const handleSubmitSelectedBookList = useCallback(async (selected)=>{
        // console.log(selected, data)
        if (!subject) {
            return;
        }
        const cls = await classMutation.mutateAsync({
            name: data.name,
            subject,
            choices: selected.map((param)=>{
                let { id  } = param;
                return {
                    sourceId: id,
                    sourceType: "workbook"
                };
            })
        });
        setUserSourceBooks({
            books: undefined
        });
        closeSelectBooksModal();
        message.info("클래스가 생성됐어요.");
        push(CLASS_INDEX_PAGE.concat("/".concat(cls.id)));
    }, [
        subject,
        classMutation,
        data,
        push,
        setUserSourceBooks,
        closeSelectBooksModal
    ]);
    const isSubmitting = useRef(false);
    useEffect(()=>{
        if (userSourceBooks.books) {
            if (userSourceBooks.type === "new" && !isSubmitting.current) {
                isSubmitting.current = true;
                handleSubmitSelectedBookList(userSourceBooks.books);
            }
        } else {
            isSubmitting.current = false;
        }
    }, [
        userSourceBooks,
        handleSubmitSelectedBookList
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: data.step === 1 && /*#__PURE__*/ _jsx(StyledModal, {
            open: isNewClassOpen,
            closable: false,
            okButtonProps: {
                style: {
                    display: "none"
                }
            },
            cancelButtonProps: {
                style: {
                    display: "none"
                }
            },
            children: /*#__PURE__*/ _jsx(NewClassStep1, {
                onCancel: closeNewClass
            })
        })
    });
};
export default NewClass;
